module.exports = __webpack_public_path__ + "static/media/icon-call.a2acf551.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-call.svg
// module id = 927
// module chunks = 0